function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onCancel", "onOk"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCssInJs } from "../../../hooks";
import { useDrawerMethod, useMount, useParams, wrapReactionHook } from '@micun/form';
import cx from 'classnames';
import TaskDetail from "../../../pages/taskList/components/TaskDetail";
import { getFlowLinkStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TaskDetailDrawer = function TaskDetailDrawer(props) {
  var onCancel = props.onCancel,
    onOk = props.onOk,
    rest = _objectWithoutProperties(props, _excluded);
  var _useDrawerMethod = useDrawerMethod(),
    render = _useDrawerMethod.render,
    setOpen = _useDrawerMethod.setOpen;
  return render({
    title: '流程详情',
    width: 570,
    className: 'ec-task-drawer',
    onClose: function onClose() {
      setOpen(false);
      onCancel();
    },
    children: /*#__PURE__*/_jsx(TaskDetail, _objectSpread({}, props))
  });
};
var useTaskDetail = function useTaskDetail() {
  var mount = useMount();
  return function (params) {
    return new Promise(function (resolve, reject) {
      var modal = mount( /*#__PURE__*/_jsx(TaskDetailDrawer, _objectSpread(_objectSpread({}, params), {}, {
        onCancel: reject,
        onOk: resolve
      })));
    });
  };
};
export var FlowLink = wrapReactionHook(function (props) {
  var prefix = 'custom-flow-link';
  var value = props.value,
    onChange = props.onChange,
    params = props.params,
    addonAfter = props.addonAfter,
    addonBefore = props.addonBefore;
  var openTaskDetail = useTaskDetail();
  var getParams = useParams(params);
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getFlowLinkStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: cx(hashId, prefix),
    onClick: function onClick() {
      return openTaskDetail(getParams()).catch(function () {});
    },
    children: [addonBefore, /*#__PURE__*/_jsx("span", {
      className: cx(hashId, 'link'),
      children: value !== null && value !== void 0 ? value : '-'
    }), addonAfter]
  }));
});